import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { TrendingUp, Calendar } from "lucide-react";

import KpiStatCard from "@/components/ui/KpiStatCard";
import { formatPilotageCurrency } from "@/lib/pilotageUi";

const RealizedRevenueClosedPeriod = ({ data }) => {
  if (!data || !data.monthly || data.monthly.length === 0) {
    return null;
  }

  const { total, monthly } = data;
  const lastMonth = monthly[monthly.length - 1];
  const closingMonthStr = lastMonth ? `${lastMonth.label.toUpperCase()}` : "";

  return (
    <div className="grid min-w-0 grid-cols-1 gap-6 lg:grid-cols-3" data-testid="pilotage-realized-revenue-closed-section">
      <div className="lg:col-span-1">
        <KpiStatCard
          label="CA Réalisé cumulé"
          value={formatPilotageCurrency(total)}
          hint={`Chiffre d'affaires cumulé du 1er janvier au dernier mois clôturé (fin ${data.period_end_label ? data.period_end_label.toLowerCase() : ""}).`}
          icon={TrendingUp}
          dataTestId="pilotage-dashboard-kpi-realized-revenue-total"
          infoNode={
            <div className="flex items-center gap-1 text-[10px] font-semibold text-emerald-400 bg-emerald-500/10 px-2 py-0.5 rounded border border-emerald-500/20 uppercase tracking-wider">
              Clôturé
            </div>
          }
        />
      </div>
      <div className="lg:col-span-2 rounded-xl border border-white/10 bg-white/[0.02] p-5">
        <div className="flex items-center justify-between mb-4">
          <div className="min-w-0">
            <h3 className="text-sm font-bold uppercase tracking-[0.18em] text-white">
              Évolution mensuelle du CA réalisé
            </h3>
            <p className="mt-1 text-xs text-slate-400">
              Historique des mois clôturés.
            </p>
          </div>
          <div className="flex items-center gap-1.5 text-xs font-semibold text-amber-400/90 bg-amber-500/10 border border-amber-500/20 px-2 py-0.5 rounded-md">
            <Calendar className="h-3.5 w-3.5" />
            Données arrêtées à fin {closingMonthStr}
          </div>
        </div>
        <div className="h-[180px] w-full min-w-0">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={monthly} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#ffffff15" vertical={false} />
              <XAxis dataKey="label" stroke="#94A3B8" fontSize={11} tickLine={false} axisLine={false} />
              <YAxis
                stroke="#94A3B8"
                fontSize={11}
                tickLine={false}
                axisLine={false}
                tickFormatter={(value) => `${Math.round(value / 1000)}k`}
              />
              <Tooltip
                cursor={{ fill: "rgba(255,255,255,0.05)" }}
                contentStyle={{
                  backgroundColor: "#0f172a",
                  border: "1px solid rgba(255,255,255,0.1)",
                  borderRadius: "12px",
                }}
                content={({ active, payload }) => {
                  if (!active || !payload?.length) return null;
                  const point = payload[0]?.payload;
                  return (
                    <div className="rounded-2xl border border-white/10 bg-slate-950/95 p-3 shadow-xl">
                      <p className="text-xs font-medium text-white">{point?.label}</p>
                      <p className="mt-1 text-xs text-slate-200">
                        CA réalisé : {formatPilotageCurrency(point?.amount)}
                      </p>
                    </div>
                  );
                }}
              />
              <Bar dataKey="amount" fill="#3B82F6" radius={[4, 4, 0, 0]} maxBarSize={30} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default RealizedRevenueClosedPeriod;
